define([
	"dojo/_base/declare",
	"Quality/EditTestRun"
], function(declare,EditTestRun) {

	return declare(EditTestRun, {
		bSampleContext: true
	});
});